import { CommonModule } from '@angular/common';

import { NavbarV2Component } from './navbar-v2/navbar-v2.component';
import { SidebarV2Component } from './sidebar-v2/sidebar-v2.component';
import { ChannelNavbarV2Component } from './channel-navbar-v2/channel-navbar-v2.component';
import { PreviewV2Component } from './preview-v2/preview-v2.component';
import { EditBlockCommentsV2Component } from './edit-block-comments-v2/edit-block-comments-v2.component';
import { HeartbeatComponent } from '../common/heartbeat/heartbeat.component';
import { ExportDialogV2Component } from './export-dialog-v2/export-dialog-v2.component';
import { AddBlockModalV2Component } from './add-block-modal-v2/add-block-modal-v2.component';
import { VersionDialogV2Component } from './review/version-dialog-v2/version-dialog-v2.component';

/**
 * Everything template-editor-v2.component.html references directly. Each child
 * component below imports whatever it needs internally (block components, the
 * existing app-add-block, Optimus UI modules, CDK drag-drop) - kept out of this
 * list to keep the orchestrator's own surface small.
 */
export const TEMPLATE_EDITOR_V2_IMPORTS = [
  CommonModule,
  NavbarV2Component,
  SidebarV2Component,
  ChannelNavbarV2Component,
  PreviewV2Component,
  EditBlockCommentsV2Component,
  HeartbeatComponent,
  ExportDialogV2Component,
  AddBlockModalV2Component,
  VersionDialogV2Component,
] as const;
